require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./wob-shareholder-misalignment.json") })
        }
      }, "path---wob-shareholder-misalignment");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---wob-shareholder-misalignment!./.cache/json/wob-shareholder-misalignment.json
// module id = 1269
// module chunks = 231608221292675